'use client';

import React, { useState } from 'react';
import { Bell, Search, ChevronDown, Settings } from 'lucide-react';
import Link from 'next/link';

export default function ManagerTopbar() {
  const [notifOpen, setNotifOpen] = useState(false);

  const notifications = [
    { id: 'notif-1', text: 'New booking: Court 2 — Thomas Müller', time: '5 min ago', unread: true },
    { id: 'notif-2', text: 'Cancellation: Court 1 — Marie Dupont', time: '22 min ago', unread: true },
    { id: 'notif-3', text: 'Payment confirmed: €45.00 — Court 3', time: '1h ago', unread: true },
    { id: 'notif-4', text: 'New review: 4.8 ★ from Lena Schneider', time: '3h ago', unread: false },
    { id: 'notif-5', text: 'Weekly report ready to download', time: 'Yesterday', unread: false },
  ];

  const unreadCount = notifications?.filter((n) => n?.unread)?.length;

  return (
    <header className="h-16 bg-white border-b border-border flex items-center px-6 gap-4 sticky top-0 z-40">
      {/* Search */}
      <div className="flex-1 max-w-md relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search bookings, guests..."
          className="w-full pl-9 pr-4 py-2 text-sm bg-muted rounded-xl border-0 focus:outline-none focus:ring-2 focus:ring-primary/30 placeholder:text-muted-foreground"
        />
      </div>
      <div className="flex items-center gap-2 ml-auto">
        {/* Date */}
        <span className="hidden md:block text-sm text-muted-foreground font-mono tabular-nums">
          Sat, 19 Apr 2026
        </span>

        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => setNotifOpen(!notifOpen)}
            className="relative p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
          >
            <Bell size={18} />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-destructive" />
            )}
          </button>

          {notifOpen && (
            <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-2xl shadow-modal border border-border animate-fade-in z-50">
              <div className="px-4 py-3 border-b border-border flex items-center justify-between">
                <p className="text-sm font-semibold text-foreground">Notifications</p>
                <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-0.5 rounded-full">
                  {unreadCount} new
                </span>
              </div>
              <div className="divide-y divide-border max-h-72 overflow-y-auto">
                {notifications?.map((n) => (
                  <div
                    key={n?.id}
                    className={`px-4 py-3 hover:bg-muted/50 transition-colors cursor-pointer ${n?.unread ? 'bg-primary/3' : ''}`}
                  >
                    <p className={`text-sm ${n?.unread ? 'font-medium text-foreground' : 'text-muted-foreground'}`}>
                      {n?.text}
                    </p>
                    <p className="text-xs text-muted-foreground mt-0.5">{n?.time}</p>
                  </div>
                ))}
              </div>
              <div className="px-4 py-2.5 border-t border-border">
                <button className="text-xs font-medium text-primary hover:underline">
                  Mark all as read
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Settings */}
        <Link
          href="/hotel-manager-dashboard"
          className="p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
        >
          <Settings size={18} />
        </Link>

        {/* User */}
        <button className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-xl hover:bg-muted transition-all duration-150">
          <div className="w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center">
            <span className="text-xs font-semibold text-primary">KA</span>
          </div>
          <span className="hidden sm:block text-sm font-medium text-foreground">Karim A.</span>
          <ChevronDown size={13} className="text-muted-foreground" />
        </button>
      </div>
    </header>
  );
}